import dynamic from 'next/dynamic';

import type { UserDocumentsModalImplementationProps } from './user-documents-modal-implementation';

const UserDocumentsModalImplementation = dynamic(
  () =>
    import('./user-documents-modal-implementation').then(
      (module) => module.UserDocumentsModalImplementation
    ),
  { ssr: false, loading: () => null }
);

export const UserDocumentsModal = (props: UserDocumentsModalImplementationProps) => {
  if (!props.open) {
    return null;
  }

  return <UserDocumentsModalImplementation {...props} />;
};
